import { render, staticRenderFns } from "./SuperSyndicate.vue?vue&type=template&id=10f35395&scoped=true&"
import script from "./SuperSyndicate.vue?vue&type=script&lang=js&"
export * from "./SuperSyndicate.vue?vue&type=script&lang=js&"
import style0 from "./SuperSyndicate.vue?vue&type=style&index=0&id=10f35395&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f35395",
  null
  
)

export default component.exports